var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.viewportClasses, attrs: { id: "viewport", role: "tablist" } },
    [
      _vm.$store.state.appLoaded
        ? _c("Sidebar", { attrs: { overlay: _vm.$refs.overlay } })
        : _vm._e(),
      _c("div", {
        ref: "overlay",
        attrs: { id: "sidebar-overlay", "aria-hidden": "true" },
        on: {
          click: function ($event) {
            return _vm.$store.commit("sidebarOpen", false)
          },
        },
      }),
      _c("router-view", { ref: "window" }),
      _c("Mentions"),
      _c("ImageViewer", { ref: "imageViewer" }),
      _c("ContextMenu", { ref: "contextMenu" }),
      _c("ConfirmDialog", { ref: "confirmDialog" }),
      _c("div", { attrs: { id: "upload-overlay" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }